import React from "react";

export default function SavedListIcon({ active }) {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 13"
      fill={active ? "#FFFDFE" : "#2B56A3"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="7.33838"
        width="16.6366"
        height="1.44953"
        rx="0.5"
        fill={active ? "#FFFDFE" : "#2B56A3"}
        stroke={active ? "#FFFDFE" : "#2B56A3"}
      />
      <rect
        x="0.5"
        y="0.5"
        width="16.6366"
        height="3.89906"
        rx="0.5"
        fill={active ? "#FFFDFE" : "#2B56A3"}
        stroke={active ? "#FFFDFE" : "#2B56A3"}
      />
      <rect
        x="0.5"
        y="12.2172"
        width="16.6366"
        height="1.44953"
        rx="0.5"
        fill={active ? "#FFFDFE" : "#2B56A3"}
        stroke={active ? "#FFFDFE" : "#2B56A3"}
      />
    </svg>
  );
}
